import { FunctionComponent, lazy, Suspense, useEffect, useState } from 'react'

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import useEnableTrackingDebug from '@hooks/useEnableTrackingDebug'
import useShouldShowDevtoolsOnProd from '@hooks/useShouldShowDevtoolsOnProd'

const ReactQueryDevtoolsProduction = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({
      default: d.ReactQueryDevtools,
    }),
  ),
)

const TanstackQueryDevtools: FunctionComponent = () => {
  const shouldShowDevtoolsOnProd = useShouldShowDevtoolsOnProd()
  const enableTrackingDebugLog = useEnableTrackingDebug()

  const [showProdDevtools, setShowProdDevtools] = useState<boolean>(
    process.env.NODE_ENV !== 'development' && shouldShowDevtoolsOnProd,
  )

  useEffect(() => {
    setShowProdDevtools(
      process.env.NODE_ENV !== 'development' && shouldShowDevtoolsOnProd,
    )
  }, [shouldShowDevtoolsOnProd])

  useEffect(() => {
    if (enableTrackingDebugLog) {
      try {
        localStorage.setItem('TanstackQueryDevtools.filter', 'event-debugger')
        localStorage.setItem('TanstackQueryDevtools.sort', 'last updated')
        localStorage.setItem('TanstackQueryDevtools.sortOrder', '-1')
      } catch {}
    }
  }, [enableTrackingDebugLog])

  return (
    <>
      <ReactQueryDevtools position="bottom" buttonPosition="bottom-left" />
      {showProdDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsProduction
            position="bottom"
            buttonPosition="bottom-left"
          />
        </Suspense>
      )}
    </>
  )
}

export default TanstackQueryDevtools
